import './styles.scss'
import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { Button, Col, Row } from 'reactstrap'
import { I18n } from 'react-redux-i18n'

import { marketingAct } from '../../../redux/actions'
import Header from './Header'
import List from './List'
import FormEdit from './FormEdit'
import FormCreate from './FormCreate'
import ModalDelete from './ModalDelete'
import StatusCircles from 'components/StatusCircles'
import Nixi1Spinner from 'components/Nixi1Spinner'

const View = ({ setActiveTemplate, templateOptions, currentTemplate, templates, getAllTemplates, deleteTemplate, getTemplateVariables }) => {
  const { pathname } = useLocation()
  const isChat = pathname === '/dashboard/conversations/templates'

  const [formCreate, setFormCreate] = useState({ isOpen: false })
  const [formEdit, setFormEdit] = useState({ isOpen: false })
  const [isFetching, setIsFetching] = useState(true)
  const [isOpenModal, setIsOpenModal] = useState(false)
  const [deleteTemplateItem, setDeleteTemplateItem] = useState({})

  useEffect(() => {
    Promise.all([getTemplateVariables(), getAllTemplates(isChat)])
      .catch(console.error)
      .finally(() => setIsFetching(false))
  }, [getAllTemplates, getTemplateVariables, isChat])

  const handleDeleteTemplate = (id) => {
    setIsFetching(true)
    deleteTemplate(id)
      .then(() => {
        getAllTemplates(isChat)
          .catch(console.error)
          .finally(() => setIsFetching(false))
      })
      .catch(console.error)
      .finally(() => {
        setIsFetching(true)
        setIsOpenModal(false)
      })
  }

  return (
    <>
      <Header title={I18n.t(isChat ? 'dashboard_templates' : 'marketing_templates_title')} />

      <Row className='my-3'>
        <Col sm={12} xs={3} xl={3}>
          <List setActiveTemplate={setActiveTemplate} templateOptions={templateOptions} currentTemplate={currentTemplate} />
        </Col>
        <Col sm={12} xs={9} xl={9}>
          <div className='template-list-content'>
            {isFetching && <Nixi1Spinner width='25px' height='25px' />}
            <ul id={'template-list-content-ul'}>
              {(templates[currentTemplate] || []).map((t) => {
                let withStatus = false
                let status = {}

                if (t.channelsStatus?.length) {
                  withStatus = true
                  status = t.channelsStatus?.reduce((preV, next) => {
                    const nStatus = next?._id?.toLowerCase()
                    if (!nStatus) return preV

                    if (preV[nStatus]) {
                      preV[nStatus] = next
                    } else {
                      if (preV.rest?.total) preV.rest.total += next.total
                      else preV.rest = next
                    }

                    return preV
                  }, { approved: {}, draft: {}, rejected: {}, pending: {}, rest: {} })
                }

                const listClass = currentTemplate === 'whatsapp_whatsapp' && withStatus ? ' list_with-circles' : ''

                return (
                  <li key={t._id} className={formEdit.isOpen && formEdit._id === t._id ? 'form' : `list${listClass}`}>
                    {formEdit.isOpen && formEdit._id === t._id ? (
                      <FormEdit currentTemplate={currentTemplate} setFormEdit={setFormEdit} template={t} />
                    ) : (
                      <Row className='d-flex justify-content-between align-items-center'>
                        {currentTemplate !== 'whatsapp_whatsapp' ? (
                          <Col xs={10}>{t.name}</Col>
                        ) : (
                          <>
                            <Col xs={5}>{t.name}</Col>
                            <Col xs={5} className='template-list__status-circles-container'>
                              {withStatus ? (
                                <StatusCircles
                                  title={I18n.t('dashboard_approved')}
                                  status={[
                                    { value: status.approved.total, colorType: status.approved._id }
                                  ]}
                                />
                              ) : null}
                              {withStatus ? (
                                <StatusCircles
                                  title={I18n.t('dashboard_pending')}
                                  status={
                                    [status.pending, status.rejected, status.rest]
                                      .map(status => ({
                                        value: status.total,
                                        colorType: status._id
                                      }))
                                  }
                                />
                              ) : null}
                              {withStatus ? (
                                <StatusCircles
                                  title={I18n.t('dashboard_drafts')}
                                  status={[
                                    { value: status.draft.total, colorType: status.draft._id }
                                  ]}
                                />
                              ) : null}
                            </Col>
                          </>
                        )}
                        <Col className='text-right'>
                          <i
                            className='fa fa-pencil pointer'
                            onClick={() => {
                              setFormCreate({ isOpen: false })
                              setFormEdit({
                                isOpen: true,
                                _id: t._id,
                              })
                            }}
                          ></i>
                        </Col>
                        <Col className='text-left'>
                          <i
                            className='fa fa-trash pointer'
                            onClick={() => {
                              setDeleteTemplateItem({ _id: t._id, name: t.name })
                              setIsOpenModal(true)
                            }}
                          ></i>
                        </Col>
                      </Row>
                    )}
                  </li>
                )
              })}
            </ul>
            {!formCreate.isOpen ? (
              <Button
                outline
                color='primary'
                size='lg'
                onClick={() => {
                  setFormEdit({ isOpen: false })
                  setFormCreate({ isOpen: true })
                }}
              >
                <i className='fa fa-plus-circle'></i> {I18n.t('dashboard_add-template')}
              </Button>
            ) : (
              <div style={{ padding: '15px' }}>
                <FormCreate currentTemplate={currentTemplate} setFormCreate={setFormCreate} setFormEdit={setFormEdit} />
              </div>
            )}
          </div>
        </Col>
      </Row>
      <ModalDelete
        isOpenModal={isOpenModal}
        setIsOpenModal={setIsOpenModal}
        handleDeleteTemplate={handleDeleteTemplate}
        id={deleteTemplateItem._id}
        name={deleteTemplateItem.name}
      />
    </>
  )
}

const mapStateToProps = (state) => ({
  templates: state.marketing.templates,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getAllTemplates: marketingAct.getAllTemplates,
      deleteTemplate: marketingAct.deleteTemplate,
      getTemplateVariables: marketingAct.getTemplateVariables,
    },
    dispatch
  )

export default connect(mapStateToProps, mapDispatchToProps)(View)
